export class UserGroupAssignment {
  userId: string;
  groupId: string;
  role: string;
  groupName?: string;
}
